import { Migration2_0_15 } from './2_0_15';
import { Migration2_7_0 } from './2_7_0';
import { Migration2_20_0 } from './2_20_0';
import { Migration2_36_0 } from './2_36_0';
import { Migration2_42_0 } from './2_42_0';
import { Migration2_167_6 } from './2_167_6';
import { Migration2_168_6 } from './2_168_6';
import { Migration2_202_1 } from './2_202_1';
import { Migration2_208_0 } from './2_208_0';
import { Migration2_209_0 } from './2_209_0';
export const MigrationClasses = [
    Migration2_0_15,
    Migration2_7_0,
    Migration2_20_0,
    Migration2_36_0,
    Migration2_42_0,
    Migration2_167_6,
    Migration2_168_6,
    Migration2_202_1,
    Migration2_208_0,
    Migration2_209_0,
];
export { Migration2_0_15, Migration2_7_0, Migration2_20_0, Migration2_36_0, Migration2_42_0, Migration2_167_6, Migration2_168_6, Migration2_202_1, Migration2_208_0, Migration2_209_0, };
